import { render, staticRenderFns } from "./SingleInputOtp.vue?vue&type=template&id=67e5907c&scoped=true"
import script from "./SingleInputOtp.vue?vue&type=script&lang=js"
export * from "./SingleInputOtp.vue?vue&type=script&lang=js"
import style0 from "./SingleInputOtp.vue?vue&type=style&index=0&id=67e5907c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e5907c",
  null
  
)

export default component.exports